module.exports = __webpack_public_path__ + "img/nav05_h.89f7ca23.png";